import { ChakraProps, chakra } from '@chakra-ui/react';
import * as React from 'react';

export const ImageFallbackMavericks: React.FC<
  ChakraProps & { title: string }
> = (props) => {
  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 580 193"
      fill="none"
      role="img"
      {...props}
    >
      <title>{props.title}</title>
      <path d="M0 0H580V193H0V0Z" fill="#E2E8F0" />
      <mask
        id="mask0_3083_16547"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="580"
        height="193"
      >
        <path d="M0 0H580V193H0V0Z" fill="#E2E8F0" />
      </mask>
      <g mask="url(#mask0_3083_16547)">
        <path
          opacity="0.6"
          d="M157.481 79.6258C-9.30308 80.7534 -46.6099 163.721 -77.3333 205.063H710.5C418.629 195.197 365.96 78.2164 157.481 79.6258Z"
          fill="#CBD5E0"
        />
        <path
          opacity="0.6"
          d="M466.801 79.6048C560.936 78.8459 581.993 23.0026 599.333 -4.82422H154.667C319.404 1.81626 349.131 80.5535 466.801 79.6048Z"
          fill="#CBD5E0"
        />
      </g>
    </chakra.svg>
  );
};
